module.exports = __webpack_public_path__ + "img/akademia-piotra-reissa-logo.4a1e4103.png";